<template>
  <article class="tcard" :class="{ 'tcard--rec': tarif.empfehlung_type > 0 }">
    <div v-if="tarif.empfehlung_type > 0" class="tcard__rec-banner">
      <span v-if="tarif.empfehlung_type == 3"
        >Empfehlung · Beste Leistung</span
      >
      <span v-else>Empfehlung · Sehr gute Alternative</span>
    </div>

    <header class="tcard__head">
      <div class="tcard__title">
        <h2 class="tcard__name">{{ tarif.un_name }}</h2>
        <div class="tcard__meta">
          {{ tarif.tarif_title }}
          <span class="tcard__sep">·</span>
          <span class="tcard__id">Tarif-Nr. {{ tarif.tarif_id }}</span>
        </div>
        <router-link
          v-if="tarif.antraglink"
          :to="tarif.antraglink"
          class="tcard__title-link"
        >
          Jetzt Antrag &amp; Infopaket anfordern →
        </router-link>
      </div>

      <div class="tcard__rank">
        <RankInfo :tarif="tarif" :berechnung="berechnung" />
      </div>

      <div class="tcard__price">
        <a
          class="tcard__price-num"
          @click="berechnungStore.setShowPop(tarif, 'beitragsentwicklung')"
        >
          {{ tarif.preis_value }}&nbsp;€
        </a>
        <span class="tcard__price-unit">mtl.</span>
        <a
          class="tcard__price-link"
          @click="berechnungStore.setShowPop(tarif, 'beitragsentwicklung')"
        >
          Beitragsentwicklung →
        </a>
        <div
          v-if="berechnung.ber_segment <= 1 && tarif.zuschlag_zahn > 0"
          class="tcard__price-hint"
        >
          inkl. {{ tarif.zuschlag_zahn }} € Zuschlag für
          <span v-if="berechnung.ber_luecke == 1">1 fehlenden Zahn</span>
          <span v-else>{{ berechnung.ber_luecke }} fehlende Zähne</span>
        </div>
        <div
          v-if="
            (berechnung.ber_segment == 3 || berechnung.ber_segment == 2) &&
            tarif.zuschlag_sehhilfe > 0
          "
          class="tcard__price-hint"
        >
          inkl. {{ tarif.zuschlag_sehhilfe }} € Zuschlag für Sehhilfen
        </div>
      </div>

      <router-link
        v-if="tarif.antraglink"
        :to="tarif.antraglink"
        class="tcard__cart"
        :title="`Antrag & Infopaket – ${tarif.un_name}`"
      >
        <v-icon icon="mdi-cart-outline" size="22" />
      </router-link>
    </header>

    <div class="tcard__body">
      <div class="tcard__main">
        <div v-if="tarif.showBap == 1" class="tcard__bap">
          <v-icon
            icon="mdi-alert-outline"
            size="16"
            class="mr-1"
            color="error"
          />
          <strong>Hinweis Beitragserhöhung:</strong>
          {{ tarif.tarif_bap_hinweis }}
        </div>

        <div v-if="tarif.spezialHinweis" class="tcard__bap">
          <v-icon
            icon="mdi-alert-outline"
            size="16"
            class="mr-1"
            color="error"
          />
          <strong>Wichtiger Hinweis:</strong>
          {{ tarif.spezialHinweis }}
        </div>

        <div class="tcard__sections">
          <LueckeLeistung
            v-if="
              berechnung.ber_segment <= 1 &&
              berechnung.ber_algo_view != 2 &&
              berechnung.ber_alter > 17 &&
              berechnung.ber_luecke > 0 &&
              berechnung.ber_luecke_vers == 1
            "
            :tarif="tarif"
            :berechnung="berechnung"
          />

          <RumpfJahr
            v-if="tarif.show_begrenzung_vorteil"
            :tarif="tarif"
            :berechnung="berechnung"
          />
          <WechselOption
            v-if="
              berechnung.ber_wechsel == 1 && tarif.tarif_wechsel_angebot > 0
            "
            :tarif="tarif"
            :berechnung="berechnung"
          />
          <SofortLeistung
            v-if="tarif.sofortversichert"
            :tarif="tarif"
            :berechnung="berechnung"
          />
          <WaizmannWert :tarif="tarif" :berechnung="berechnung" />

          <KfoInfo
            v-if="berechnung.ber_segment <= 1 && berechnung.ber_algo_view == 2"
            :tarif="tarif"
            :berechnung="berechnung"
          />
          <ErwachsenInfo
            v-if="berechnung.ber_segment <= 1 && berechnung.ber_algo_view != 2"
            :tarif="tarif"
            :berechnung="berechnung"
          />
          <BrillenInfo
            v-if="berechnung.ber_segment == 2"
            :tarif="tarif"
            :berechnung="berechnung"
          />
          <HeilInfo
            v-if="berechnung.ber_segment == 3"
            :tarif="tarif"
            :berechnung="berechnung"
          />
          <KrankInfo
            v-if="berechnung.ber_segment == 4"
            :tarif="tarif"
            :berechnung="berechnung"
          />
          <ClearmentInkl
            v-if="berechnung.ber_segment <= 1"
            :tarif="tarif"
            :berechnung="berechnung"
          />
          <WaizmannEmpfehlung
            v-if="tarif.empfehlung_type > 0"
            :tarif="tarif"
            :berechnung="berechnung"
          />
        </div>

        <footer class="tcard__foot">
          <div class="tcard__foot-row tcard__foot-row--secondary">
            <v-btn
              variant="outlined"
              rounded="0"
              class="tcard__btn"
              @click="berechnungStore.setShowPop(tarif, 'dreivergleich')"
            >
              <v-icon icon="mdi-compare" size="16" class="mr-1" />
              3 Tarife vergleichen
            </v-btn>
            <v-btn
              variant="outlined"
              rounded="0"
              class="tcard__btn"
              @click="berechnungStore.setShowPop(tarif, 'tarifbeschreibung')"
            >
              <v-icon icon="mdi-text-box-outline" size="16" class="mr-1" />
              Tarifbeschreibung
            </v-btn>
          </div>
          <div class="tcard__foot-row tcard__foot-row--primary">
            <v-btn
              v-if="tarif.antraglink"
              :to="tarif.antraglink"
              :color="berechnung.fontColorVue"
              variant="flat"
              rounded="0"
              block
              class="tcard__btn tcard__btn--primary"
            >
              <v-icon icon="mdi-file-document-outline" size="16" class="mr-1" />
              Antrag &amp; Infopaket
              <span v-if="tarif.empfehlung_type > 0" class="ml-1">| kostenlos</span>
            </v-btn>
          </div>
        </footer>
      </div>

      <aside class="tcard__aside">
        <HighlightsTarif
          class="tcard__hl"
          :showMobile="false"
          :tarif="tarif"
          :berechnung="berechnung"
        />
        <ClearmentLsk
          class="mt-2"
          v-if="berechnung.ber_segment <= 1 && tarif.tarif_clearment_lsk > 0"
          :tarif="tarif"
        />
      </aside>
    </div>
  </article>
</template>

<script setup>
  import { defineProps } from "vue";
  import { useBerechnungStore } from "@/stores/berechnung";
  import ClearmentLsk from "@/components/tarif/mini/ClearmentLsk";
  import ClearmentInkl from "@/components/tarif/mini/ClearmentInkl";
  import HighlightsTarif from "@/components/tarif/mini/HighlightsTarif";
  import WaizmannEmpfehlung from "@/components/tarif/mini/WaizmannEmpfehlung";
  import KfoInfo from "@/components/tarif/mini/zahn/KfoInfo";
  import ErwachsenInfo from "@/components/tarif/mini/zahn/ErwachsenInfo";
  import BrillenInfo from "@/components/tarif/mini/brille/BrillenInfo";
  import HeilInfo from "@/components/tarif/mini/heil/HeilInfo";
  import KrankInfo from "@/components/tarif/mini/krank/KrankInfo";
  import RumpfJahr from "@/components/tarif/mini/zahn/RumpfJahr";
  import WechselOption from "@/components/tarif/mini/zahn/WechselOption";
  import SofortLeistung from "@/components/tarif/mini/zahn/SofortLeistung";
  import LueckeLeistung from "@/components/tarif/mini/zahn/LueckeLeistung";
  import RankInfo from "@/components/tarif/mini/RankInfo";
  import WaizmannWert from "@/components/tarif/mini/WaizmannWert";

  const berechnungStore = useBerechnungStore();

  defineProps({
    tarif: { type: Object, default: () => ({}) },
    berechnung: { type: Object, default: () => ({}) },
  });
</script>

<style scoped>
  .tcard {
    background: #ffffff;
    border: 1px solid #d8dde5;
    border-radius: 0;
    margin: 0 0 14px;
    display: flex;
    flex-direction: column;
    position: relative;
  }

  .tcard--rec {
    border-color: #ffd166;
    border-left: 3px solid #f6a800;
    box-shadow: 0 1px 0 rgba(15, 76, 129, 0.04);
  }
  .tcard--rec .tcard__head {
    background: #fffbe6;
    border-bottom-color: #ffe58f;
  }
  .tcard__rec-banner {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background: #f6a800;
    color: #ffffff;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    padding: 4px 12px;
  }
  .tcard__rec-banner .v-icon {
    color: #ffffff;
  }

  .tcard__head {
    display: grid;
    grid-template-columns: auto 1fr auto auto;
    grid-template-areas: "rank title price cart";
    gap: 14px;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #eef1f6;
    background: #fafbfd;
  }
  .tcard__rank {
    grid-area: rank;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .tcard__title {
    grid-area: title;
    min-width: 0;
    text-align: left;
  }
  .tcard__name {
    font-size: 18px;
    font-weight: 700;
    color: #0f172a;
    margin: 0;
    letter-spacing: -0.2px;
    line-height: 1.2;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .tcard__meta {
    font-size: 12.5px;
    color: #6b7280;
    margin-top: 2px;
  }
  .tcard__sep {
    color: #c7ccd6;
    margin: 0 4px;
  }
  .tcard__id {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
      monospace;
    font-size: 11.5px;
  }
  .tcard__title-link {
    display: inline-block;
    margin-top: 4px;
    font-size: 12.5px;
    font-weight: 600;
    color: #0f4c81;
    text-decoration: none;
    letter-spacing: 0.2px;
  }
  .tcard__title-link:hover {
    text-decoration: underline;
  }

  .tcard__price {
    grid-area: price;
    text-align: right;
    min-width: 160px;
  }
  .tcard__price-num {
    font-size: 22px;
    font-weight: 800;
    color: #0f4c81;
    letter-spacing: -0.4px;
    font-variant-numeric: tabular-nums;
    cursor: pointer;
    text-decoration: none;
  }
  .tcard__price-num:hover {
    text-decoration: underline;
  }
  .tcard__price-unit {
    font-size: 12px;
    color: #6b7280;
    font-weight: 500;
    margin-left: 2px;
  }
  .tcard__price-link {
    display: block;
    margin-top: 2px;
    font-size: 11.5px;
    color: #0f4c81;
    cursor: pointer;
    font-weight: 600;
  }
  .tcard__price-link:hover {
    text-decoration: underline;
  }
  .tcard__price-hint {
    font-size: 11px;
    color: #6b7280;
    margin-top: 2px;
  }

  .tcard__cart {
    grid-area: cart;
    width: 40px;
    height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #d8dde5;
    border-radius: 0;
    color: #0f4c81;
    background: #ffffff;
    text-decoration: none;
    transition: background-color 0.15s ease;
  }
  .tcard__cart:hover {
    background: #f0f5fa;
    border-color: #0f4c81;
  }

  .tcard__body {
    display: grid;
    grid-template-columns: 1fr 320px;
    gap: 16px;
    padding: 14px 16px;
  }
  .tcard__main {
    min-width: 0;
  }
  .tcard__bap {
    display: flex;
    align-items: flex-start;
    gap: 4px;
    background: #fff5f0;
    border: 1px solid #f5c4ba;
    border-left: 3px solid #c62828;
    border-radius: 0;
    padding: 8px 10px;
    font-size: 13px;
    color: #b3261e;
    margin-bottom: 10px;
  }
  .tcard__sections {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  .tcard__sections > * {
    font-size: 13.5px;
  }

  .tcard__aside {
    background: #f7f9fc;
    border: 1px solid #e5e9f0;
    border-radius: 0;
    padding: 10px;
  }
  .tcard__hl {
    background: transparent !important;
    padding: 0 !important;
  }

  .tcard__foot {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 10px 0 0;
    margin-top: 10px;
    border-top: 1px dashed #eef1f6;
  }
  .tcard__foot-row {
    display: flex;
    gap: 8px;
  }
  .tcard__foot-row--secondary .tcard__btn {
    flex: 1 1 0;
  }
  .tcard__foot-row--primary {
    width: 100%;
  }
  .tcard__btn {
    border-radius: 0 !important;
    letter-spacing: 0.2px;
    font-weight: 600;
    text-transform: none;
    height: 36px !important;
  }
  .tcard__btn--primary {
    color: #ffffff !important;
  }

  @media (max-width: 720px) {
    .tcard__head {
      grid-template-columns: 1fr auto auto;
      grid-template-areas:
        "title title title"
        "rank  price cart";
      gap: 8px 10px;
    }
    .tcard__title {
      grid-area: title;
    }
    .tcard__rank {
      grid-area: rank;
      justify-self: start;
    }
    .tcard__price {
      grid-area: price;
      text-align: right;
      min-width: 0;
    }
    .tcard__cart {
      grid-area: cart;
      width: auto;
      height: 36px;
      padding: 0 10px;
    }
    .tcard__body {
      grid-template-columns: 1fr;
    }
    .tcard__btn {
      flex: 1 1 auto;
    }
  }
</style>
